import { createClientConfig } from "@repo/design-system/lib/client-registry";
import { Joblist } from "~/components/job-board/joblist-eon";
import FilterbarEonUk from "~/components/job-board/subclients/uk/filterbar-eon-uk";
import HeaderImageJobboardEonUk from "~/components/job-board/subclients/uk/headerimage-jobboard-eon-uk";
import { UnifiedJobPageTemplate } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import HeaderMainEonUk from "~/components/page-skeleton/subclients/uk/header-main-eon-uk";
import { EON_UK_PRIVACY_POLICY_URL } from "~/components/registry/constants";
import { eonUkDefault } from "./default";

export const eonUk = createClientConfig({
  components: {
    JobpageTemplate: UnifiedJobPageTemplate,
    Filterbar: FilterbarEonUk,
    Joblist,
    HeaderImageJobboard: HeaderImageJobboardEonUk,
    HeaderMain: HeaderMainEonUk,
  },
  ui: {
    searchSummaryEmpty: "Jobs at E.ON UK",
    recruiterImageBasePath: "images/recruiter/subclients/uk",
    showQuickApply: false,
    privacyPolicyHref: EON_UK_PRIVACY_POLICY_URL,
  },
  subtemplates: [eonUkDefault],
});
